import { NativeStackHeaderProps } from '@react-navigation/native-stack'
import { router, Stack } from 'expo-router'
import { Platform, View } from 'react-native'
import { StyleSheet, useUnistyles } from 'react-native-unistyles'

import DesktopSearchBar from '@/components/navigation/DesktopSearchBar'
import Header from '@/components/navigation/header/Header'
import UserAvatarButton from '@/components/navigation/UserAvatarButton'
import UniIconButton from '@/components/unistyles/UniIconButton'
import buildOrgPath from '@/utils/orgRoute'

export const unstable_settings = {
  initialRouteName: 'index',
}

export const HeaderComponent = (props: NativeStackHeaderProps) => {
  return <Header {...props} />
}

export const HeaderRight = () => {
  return (
    <View style={styles.headerRight}>
      {Platform.OS === 'web' ? (
        <DesktopSearchBar />
      ) : (
        <UniIconButton
          icon="magnify"
          onPress={() => {
            router.push(buildOrgPath('/search'))
          }}
          testID="search-icon-button"
        />
      )}

      <UserAvatarButton />
    </View>
  )
}

const FosterRootLayout = () => {
  const { theme } = useUnistyles()

  return (
    <Stack
      screenOptions={{
        contentStyle: { backgroundColor: theme.colors.background },
        header: HeaderComponent,
        headerBackVisible: true,
        headerRight: HeaderRight,
        freezeOnBlur: false,
      }}
    />
  )
}

const styles = StyleSheet.create({
  headerRight: {
    alignItems: 'center',
    flexDirection: 'row',
  },
})

export default FosterRootLayout
